import React from 'react';
import PropTypes from 'prop-types';
import './index.css';

class Arrows extends React.PureComponent {
    static propTypes = {
        nextHandle: PropTypes.func.isRequired,
        preHandle: PropTypes.func.isRequired,
        infinite: PropTypes.bool,
        current: PropTypes.number,
        total: PropTypes.number,
        extension: PropTypes.number,
    };
    static defaultProps = {};

    render() {
        const { preHandle, nextHandle, infinite, current, total, extension } = this.props;

        const Left = () => (
            <div
                key="left"
                ifeng_ui_pc_sliders-arrows_next={!infinite && current >= total + extension - 1 ? 'disable' : ''}
                onClick={nextHandle}
            />
        );

        const Right = () => (
            <div
                key="right"
                ifeng_ui_pc_sliders-arrows_pre={!infinite && current <= extension ? 'disable' : ''}
                onClick={preHandle}
            />
        );

        return [Left(), Right()];
    }
}

export default Arrows;
